import { featuredArticles } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

export default function Featured() {
  const [main, ...rest] = featuredArticles;

  return (
    <section id="featured" className="scroll-mt-20 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="深度专题"
          title="不只吃瓜，更懂热点"
          desc="在热点之外，我们更关注背后的观察与思考，用有深度的视角帮你理解这些事件为什么能火、意味着什么。"
          accentIcon="ri-search-eye-line"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {/* 主打专题 */}
          <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-card transition-shadow hover:shadow-lift">
            <div className="relative aspect-[16/9] overflow-hidden">
              <img
                src={main.image}
                alt={main.title}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                {main.tag}
              </span>
            </div>
            <div className="p-5 md:p-6">
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line" />
                  {main.date}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-time-line" />
                  约 {main.readMin} 分钟读完
                </span>
              </div>
              <a
                href="#featured"
                onClick={(e) => e.preventDefault()}
                className="mt-2 block font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl"
              >
                {main.title}
              </a>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{main.excerpt}</p>
              <a
                href="#featured"
                onClick={(e) => e.preventDefault()}
                className="mt-4 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-accent-700 transition-colors hover:text-accent-800"
              >
                阅读全文
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </article>

          {/* 其余专题列表 */}
          <div className="flex flex-col gap-5">
            {rest.map((a) => (
              <article
                key={a.id}
                className="group flex gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-3 transition-all hover:border-accent-200 hover:shadow-card md:gap-5"
              >
                <div className="w-28 shrink-0 overflow-hidden rounded-xl sm:w-40">
                  <img
                    src={a.image}
                    alt={a.title}
                    className="aspect-[4/3] h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-center">
                  <span className="inline-flex w-fit items-center rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-700">
                    {a.tag}
                  </span>
                  <a
                    href="#featured"
                    onClick={(e) => e.preventDefault()}
                    className="mt-2 line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg"
                  >
                    {a.title}
                  </a>
                  <p className="mt-1.5 hidden line-clamp-2 text-xs leading-relaxed text-foreground-600 sm:block md:text-sm">
                    {a.excerpt}
                  </p>
                  <div className="mt-2 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-calendar-line" />
                      {a.date}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-time-line" />
                      {a.readMin} 分钟
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}